
import { IChatCustom } from "@interfaces/chat/chatI";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export const chatSocketQueueSlice = createSlice({
    name: "chatSocketQueue",
    initialState: {
        chats: [],
    } as {chats: IChatCustom[]},
    reducers:{
        setChatSocketQueue: (state, action: PayloadAction<IChatCustom>) => {
            const index = state.chats.findIndex(c => action.payload.id === c.id);
            if(index === -1)
                state.chats.push(action.payload);
            else
            {
                state.chats[index] = {
                    ...state.chats[index],
                    ...action.payload
                 };
            }
        },
        removeChatsocketQueue: (state, action: PayloadAction<IChatCustom>) => {
            const filteredData = state.chats.filter(chat => chat.id !== action.payload.id);
            state.chats = filteredData;
        },
        cleanChatSocketQueue: (state) => {
            state.chats = []; 
        }
    }
});

export const {setChatSocketQueue, removeChatsocketQueue, cleanChatSocketQueue} = chatSocketQueueSlice.actions;
export default chatSocketQueueSlice.reducer;